import $ from 'jquery';

$( '.epixs-slider--products' ).slick( {
	slidesToShow:   1,
	slidesToScroll: 1,
	arrows:         false,
	dots:           true,
	autoplay:       true,
	autoplaySpeed:  8000,
	accessibility:  false,
	draggable:      true,
	speed:          600,
	infinite:       true,
	lazyLoad:       "progressive"
} );

$( '.epixs-slider--branches' ).slick( {
	slidesToShow:   4,
	slidesToScroll: 1,
	arrows:         false,
	dots:           false,
	autoplay:       true,
	autoplaySpeed:  2000,
	accessibility:  false,
	draggable:      true,
	speed:          600,
	infinite:       true,
	lazyLoad:       "progressive",
	responsive:     [
		{
			breakpoint: 1024,
			settings:   {
				slidesToShow: 3,
			}
		}
	]
} );
